import { BANK_FILE_STAGE_LABELS, type BankFileStageCode } from "@hakili/domain-types";
import { t } from "@hakili/i18n";

/** D2's words for a stage inside a transfer line (« · comité », « · conditions », « · revue »), not the product's labels (« Au comité »). */
export const lineStageWords = (code: string): string => {
  switch (code) {
    case "nouveau":
      return t("bank.equipe.ligneEtapeNouveau");
    case "revue":
      return t("bank.equipe.ligneEtapeRevue");
    case "validation":
      return t("bank.equipe.ligneEtapeValidation");
    case "offre":
      return t("bank.equipe.ligneEtapeOffre");
    case "comite":
      return t("bank.equipe.ligneEtapeComite");
    case "signature":
      return t("bank.equipe.ligneEtapeSignature");
    case "conditions":
      return t("bank.equipe.ligneEtapeConditions");
    case "decaisse":
      return t("bank.equipe.ligneEtapeDecaisse");
    case "retour":
      return t("bank.equipe.ligneEtapeRetour");
    case "refuse":
      return t("bank.equipe.ligneEtapeRefuse");
    case "perdu":
      return t("bank.equipe.ligneEtapePerdu");
    default:
      return BANK_FILE_STAGE_LABELS[code as BankFileStageCode].toLowerCase();
  }
};

/** The stage's word as a chip prints it (« Chez Hakili », « Clos »): D2's, capitalised. */
export const stageChipWords = (code: string): string => {
  const words = lineStageWords(code);
  return words.charAt(0).toUpperCase() + words.slice(1);
};

/** D2's « prochain geste » per open stage. */
const NEXT_STEP: ReadonlyMap<string, Parameters<typeof t>[0]> = new Map([
  ["nouveau", "bank.pipeline.gesteNouveau"],
  ["revue", "bank.pipeline.gesteRevue"],
  ["validation", "bank.pipeline.gesteValidation"],
  ["offre", "bank.pipeline.gesteOffre"],
  ["comite", "bank.pipeline.gesteComite"],
  ["signature", "bank.pipeline.gesteSignature"],
  ["conditions", "bank.pipeline.gesteConditions"],
  ["retour", "bank.pipeline.gesteRetour"],
]);
export const nextStepOf = (stage: string): string => {
  const key = NEXT_STEP.get(stage);
  return key === undefined ? t("common.valeur.tiret") : t(key);
};
